import React from "react";
import { matchPath, useLocation } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";
import { RoleComponentGuard } from "components";
import { Profile } from "components/popups";
import { Routes } from "constants/routes";
import { useModals } from "hooks";
import { useDevice } from "hooks";
import {
  useAccountSelector,
  useAreOnlyExternalAccountsSelect,
  useIsSharedDealSelect,
  useUserActions,
  useUserRoleSelector
} from "store";

import { ReactComponent as VerticalStick } from "../../assets/icons/vertical-stick.svg";
import { RoleName } from "../../constants";
import { Bookmark } from "../Bookmark/Bookmark";
import { LanguageSwitcher } from "../LanguageSwitcher/LanguageSwitcher";
import { AddMenu } from "./Add-menu/AddMenu";
import { AdvancedSearch } from "./Advanced-search/Advanced-search";
// import { Email } from "./Email/Email";
import { EmailButton } from "./Email/EmailButton";
import { InvestorFilters } from "./InvestorFilters";
import { MobileHeader } from "./MobileHeader";
import { Notifications } from "./notifications";

import "./Header.styles.scss";

export const Header: React.FC = () => {
  const { pathname } = useLocation();
  const isSharedDeal = useIsSharedDealSelect();
  const { isMobile } = useDevice();

  const { show_hcs_view, show_global_investor_filter, is_freemium, show_localization } = useAccountSelector() || {};
  const userRole = useUserRoleSelector();
  const { openUpgradeAccount, openUpgradePlanModal } = useModals();
  const { setInvestorFilterAction } = useUserActions();

  const isSharedWith = matchPath(pathname, Routes.deal) && isSharedDeal;
  const isShowUpgrade = useAreOnlyExternalAccountsSelect();
  const hideSearch = show_hcs_view && userRole?.name === RoleName.Investor;

  if (isMobile) {
    return <MobileHeader />;
  }

  return (
    <header className="header">
      <Stack direction="row" sx={{ gap: "20px", alignItems: "center", minWidth: 0 }}>
        <RoleComponentGuard
          availableRoles={[RoleName.Admin, RoleName.Analyst]}
          hideChild={!show_global_investor_filter}
        >
          <InvestorFilters onFiltersChange={setInvestorFilterAction} />
        </RoleComponentGuard>
        {isSharedWith && (
          <Box sx={{ bgcolor: "#FBE3D3", p: "1px 5px", borderRadius: "5px" }}>
            <Typography
              sx={{ fontSize: "12px", lineHeight: "16px", fontWeight: 400, color: "#071F35", whiteSpace: "nowrap" }}
            >
              Shared with me
            </Typography>
          </Box>
        )}
      </Stack>
      {!hideSearch && <AdvancedSearch />}
      <Stack direction="row" sx={{ gap: "16px", alignItems: "center" }}>
        {Boolean(is_freemium) && (
          <Button onClick={openUpgradePlanModal} size="sm" variant="contained">
            Upgrade
          </Button>
        )}
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
          <>
            <VerticalStick width="3px" fill="#CED6D8" height="14px" />
          </>
        </RoleComponentGuard>
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
          <>
            <Bookmark />
            <VerticalStick width="3px" fill="#CED6D8" height="14px" />
          </>
        </RoleComponentGuard>
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
          {/* <Email /> */}
          <EmailButton />
          <VerticalStick width="3px" fill="#CED6D8" height="14px" />
        </RoleComponentGuard>
        {/* <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
            <AppMenu>
              <AppsIcon />
            </AppMenu>
          </RoleComponentGuard> */}
        {/* <VerticalStick width="3px" fill="#CED6D8" height="14px"  /> */}
        {isShowUpgrade && (
          <RoleComponentGuard availableRoles={[RoleName.Guest, RoleName.Viewer]}>
            <>
              <Button onClick={openUpgradeAccount} size="sm" variant="contained">
                Upgrade
              </Button>
              <VerticalStick width="3px" fill="#CED6D8" height="14px" />
            </>
          </RoleComponentGuard>
        )}
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer]}>
          {show_localization && <LanguageSwitcher />}
        </RoleComponentGuard>
        {userRole?.name !== RoleName.Investor && (
          <>
            <Notifications />
            <VerticalStick width="3px" fill="#CED6D8" height="14px" />
          </>
        )}
        <Profile />
        <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
          <AddMenu />
        </RoleComponentGuard>
      </Stack>
    </header>
  );
};
